import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  ReferenceField,
  EditButton,
  DeleteButton,
  CreateButton,
  TopToolbar,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CustomEmptyState } from '../../components/CustomEmptyState';

const StatusField = () => {
  const record = useRecordContext();
  if (!record?.status) {
    return null;
  }

  const getColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'success';
      case 'inactive':
        return 'default';
      case 'completed':
        return 'info';
      default:
        return 'default';
    }
  };

  return <Chip label={record.status} color={getColor(record.status)} size="small" />;
};

const VehicleField = () => {
  const record = useRecordContext();
  if (!record) {
    return null;
  }

  const parts = [record.jobVehicleYear, record.jobVehicleMake, record.jobVehicleModel].filter(
    Boolean
  );

  return <span>{parts.join(' ') || '-'}</span>;
};

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export const DriverVehicleList = () => {
  const navigate = useNavigate();

  return (
    <List
      perPage={25}
      sort={{ field: 'id', order: 'DESC' }}
      actions={<ListActions />}
      empty={
        <CustomEmptyState
          resource="driver-vehicles"
          onAction={() => navigate('/driver-vehicles/create')}
        />
      }
    >
      <Datagrid>
        <TextField source="id" />
        <ReferenceField source="driverId" reference="drivers" link="show">
          <ReferenceField source="userId" reference="users" link={false}>
            <TextField source="name" />
          </ReferenceField>
        </ReferenceField>
        <VehicleField />
        <TextField source="jobVehicleUserStatus" label="User Status" />
        <NumberField source="lengthMonths" label="Duration (Months)" />
        <TextField source="mode" />
        <StatusField />
        <TextField source="typeOther" label="Other Type" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
